// PricingService.js

import { getEnvVar } from '../utils/helpers';

const PricingService = {
  config: {
	apiKey: process.env.REACT_APP_AIRTABLE_API_KEY,
    baseId: process.env.REACT_APP_AIRTABLE_BASE_ID,
	tableName: 'Pricing',
	viewName: 'Grid view',
  },

  cache: {
	pricing: null,
	lastFetchTime: null,
	duration: 5 * 60 * 1000, // 5 minutes
  },

  defaults: {
	baseCostPerSqFt_Bifold: 100,
	retailCostPerSqFt_Bifold: 323.5,
	baseCostPerSqFt_MultiSlide: 120,
	retailCostPerSqFt_MultiSlide: 375,
	screenCostPerSqFt: 25,
  },

  async fetchPricing() {
	const url = `https://api.airtable.com/v0/${this.config.baseId}/${this.config.tableName}`;
	const response = await fetch(url, {
	  headers: {
		Authorization: `Bearer ${this.config.apiKey}`,
		'Content-Type': 'application/json',
	  },
	});
	if (!response.ok) return this.defaults;
	const data = await response.json();
	const pricingRecord = data.records[0];
	const pricing = {
	  baseCostPerSqFt_Bifold: Number(pricingRecord.fields.baseCostPerSqFt_Bifold) || this.defaults.baseCostPerSqFt_Bifold,
	  retailCostPerSqFt_Bifold: Number(pricingRecord.fields.retailCostPerSqFt_Bifold) || this.defaults.retailCostPerSqFt_Bifold,
	  baseCostPerSqFt_MultiSlide: Number(pricingRecord.fields.baseCostPerSqFt_MultiSlide) || this.defaults.baseCostPerSqFt_MultiSlide,
	  retailCostPerSqFt_MultiSlide: Number(pricingRecord.fields.retailCostPerSqFt_MultiSlide) || this.defaults.retailCostPerSqFt_MultiSlide,
	  screenCostPerSqFt: Number(pricingRecord.fields.screenCostPerSqFt) || this.defaults.screenCostPerSqFt,
	};

	console.log('Fetched pricing data from Airtable:', pricing);

	return pricing;
  },

  async getPricing() {
	const now = Date.now();
	if (this.cache.pricing && this.cache.lastFetchTime && now - this.cache.lastFetchTime < this.cache.duration) {
	  return this.cache.pricing;
	}
	const pricing = await this.fetchPricing();
	this.cache.pricing = pricing;
	this.cache.lastFetchTime = now;
	return pricing;
  },

  async calculateCost(squareFootage, doorType, hasScreen = false) {
	const pricing = await this.getPricing();
	const baseCostPerSqFt =
	  doorType === 'Bi-Fold' ? pricing.baseCostPerSqFt_Bifold : pricing.baseCostPerSqFt_MultiSlide;
	const retailCostPerSqFt =
	  doorType === 'Bi-Fold' ? pricing.retailCostPerSqFt_Bifold : pricing.retailCostPerSqFt_MultiSlide;
	const baseCost = squareFootage * baseCostPerSqFt;
	const screenCost = hasScreen ? squareFootage * pricing.screenCostPerSqFt : 0;
	const retailCost = squareFootage * retailCostPerSqFt + screenCost;
	return {
	  totalCost: baseCost + screenCost,
	  retailCost: retailCost,
	  savings: retailCost - (baseCost + screenCost),
	  baseCost: baseCost + screenCost,
	};
  },
};

export default PricingService;
